'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.error) {
        // theme.labelColor = theme.errorLabelColor;
    }

    if (this.props.inline) {
        theme.display = 'inline-block';
    }

    var bullet = {
        borderRadius: '50%',
        width: theme.gutter * 1.5 + 'px',
        height: theme.gutter * 1.5 + 'px',
        display: 'inline-block',
        margin: '0 ' + theme.gutter + 'px',
        borderWidth: '1px',
        borderStyle: 'solid',
        transition: theme.mainTransition
    };

    var height = (0, _pixelToNumber2.default)(theme.lineHeight) + theme.gutter * 2,
        iconTop = ((0, _pixelToNumber2.default)(theme.lineHeight) - theme.gutter * 3) / 2;

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            width: '300px',
            display: theme.display
        },
        dial: {
            zoom: 1,
            position: 'relative',

            '&:after': {
                clear: 'both',
                content: '""',
                display: 'block',
                height: 0
            }
        },
        label: {
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            color: theme.labelColor,
            width: '100%',
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            display: 'block',
            textAlign: 'center'
        },
        digit: {
            display: 'block',
            float: 'left',
            margin: 0,
            border: '0 none',
            color: theme.color,
            boxSizing: 'border-box',
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            padding: theme.gutter + 'px 0',
            width: '100px',
            background: theme.background,
            cursor: 'pointer',
            transition: 'color ' + theme.transitionDuration + ' ' + theme.transitionFunction,
            position: 'relative',
            marginBottom: theme.gutter * 2 + 'px',
            height: height + 'px',

            '&>*': {
                // display: 'inline-block',
                // verticalAlign: 'middle',
            },

            '&:focus': {
                outline: '0 none',
                color: theme.focusColor,
                backgroundColor: theme.focusBackground
            },

            '&:hover': {
                color: theme.hoverColor,
                backgroundColor: theme.hoverBackground
            },

            '&:active': {
                outline: '0 none',
                color: theme.activeColor,
                backgroundColor: theme.activeBackground
            }
        },
        bullet: Object.assign({}, bullet, {
            background: theme.bulletIdleBackground,
            borderColor: theme.bulletIdleBorderColor
        }),
        bulletFilled: Object.assign({}, bullet, {
            background: theme.bulletFilledBackground,
            borderColor: theme.bulletFilledBorderColor
        }),
        bulletWrapper: {
            textAlign: 'center',
            padding: theme.gutter * 2 + 'px 0'
        },
        animation: {
            position: 'absolute',
            width: '28px',
            height: '28px',
            backgroundColor: theme.animationBackgroundColor,
            borderRadius: '50%',

            '&-enter': {
                transition: 'opacity 2s ' + theme.animationTransitionFunction + ', transform 1s ' + theme.animationTransitionFunction,
                opacity: 0.75,
                transform: 'scale(0)'
            },

            '&-enter-active': {
                opacity: 0,
                transform: 'scale(3)'
            }
        },
        clear: {
            cursor: 'pointer',
            display: 'inline-block',
            width: theme.gutter * 3,
            height: theme.gutter * 3,
            backgroundImage: theme.clearBackgroundImage,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            position: 'relative',
            top: iconTop + 'px',

            '&:hover': {
                backgroundImage: theme.clearBackgroundImageHover
            }
        },
        deleteDigit: {
            cursor: 'pointer',
            display: 'inline-block',
            width: theme.gutter * 3,
            height: theme.gutter * 3,
            backgroundImage: theme.deleteDigitBackgroundImage,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            position: 'relative',
            top: iconTop + 'px',

            '&:hover': {
                backgroundImage: theme.deleteDigitBackgroundImageHover
            }
        },
        input: {
            position: 'absolute',
            zIndex: -1,
            visibility: 'hidden',
            top: 0,
            left: 0
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        bulletWrapper: (0, _aphroditeJss.css)(styleList.bulletWrapper),
        bullet: (0, _aphroditeJss.css)(styleList.bullet),
        bulletFilled: (0, _aphroditeJss.css)(styleList.bulletFilled),
        digit: (0, _aphroditeJss.css)(styleList.digit),
        label: (0, _aphroditeJss.css)(styleList.label),
        dial: (0, _aphroditeJss.css)(styleList.dial),
        animation: (0, _aphroditeJss.css)(styleList.animation),
        deleteDigit: (0, _aphroditeJss.css)(styleList.deleteDigit),
        clear: (0, _aphroditeJss.css)(styleList.clear),
        input: (0, _aphroditeJss.css)(styleList.input)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _clear = require('../img/clear.svg');

var _clear2 = _interopRequireDefault(_clear);

var _clear_hover = require('../img/clear_hover.svg');

var _clear_hover2 = _interopRequireDefault(_clear_hover);

var _deleteDigitHover = require('../img/deleteDigitHover.svg');

var _deleteDigitHover2 = _interopRequireDefault(_deleteDigitHover);

var _deleteDigit = require('../img/deleteDigit.svg');

var _deleteDigit2 = _interopRequireDefault(_deleteDigit);

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        display: 'block',
        color: theme.tInactive,
        fontSize: theme.tsXXLarge,
        lineHeight: theme.tlXXLarge,
        background: 'transparent',
        transitionDuration: theme.transitionDuration,
        transitionFunction: theme.transitionFunction,

        animationBackgroundColor: theme.elLight,
        animationTransitionFunction: theme.transitionFunction,

        focusColor: theme.tInactive,
        focusBackground: 'transparent',

        hoverColor: theme.tFilled,
        hoverBackground: 'transparent',

        activeColor: theme.tHint,
        activeBackground: 'transparent',

        labelColor: theme.tLabel,
        errorLabelColor: theme.tError,
        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,

        bulletIdleBackground: '#e0e0e0',
        bulletIdleBorderColor: '#e0e0e0',
        bulletFilledBackground: theme.elAccent,
        bulletFilledBorderColor: theme.elAccent,

        clearBackgroundImage: 'url("' + _clear2.default + '")',
        clearBackgroundImageHover: 'url("' + _clear_hover2.default + '")',

        deleteDigitBackgroundImage: 'url("' + _deleteDigit2.default + '")',
        deleteDigitBackgroundImageHover: 'url("' + _deleteDigitHover2.default + '")'
    };
};